import React, { Component, Fragment, useState, useEffect } from "react";

import { getUserContent } from "../../Features/SiteSettings/siteSettingSlice";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useDispatch } from "react-redux";

import { useCustomizeContext } from "../../context";

const Terms = (props) => {

   let dispatch = useDispatch();

   const [userContentRes, setUserContentRes] = useState("");
   const [content, setContent] = useState("");
   const [title, setTitle] = useState("");
   const [termsimg, setTermsimg] = useState();


   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);

   const {
      loader: {
         setLoading,
      },
      languageContext: {
         language, setLanguage,
         changeLanguageRes, setChangeLanguageRes,
      }
   } = useCustomizeContext();

   useEffect(() => {
      userContent();
   }, [changeLanguageRes]);


   useEffect(() => {
      document.body.classList.remove("SideMenuOpen");
   }, []);


   const userContent = async () => {
      setLoading(true);
      let res = await dispatch(getUserContent({ type: "user", "language": localStorage.getItem('lang') }));
      setTimeout(() => {
         if (res?.status) {
            setUserContentRes(res?.data);
            setTitle(res?.data[2]?.title);
            setContent(res?.data[2]?.content);
            setTermsimg(res?.data[2]?.image)
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 1000);

   }

   return (
      <Fragment>
         <Header />
         <div class="mainbody-content">
            <Sidebar />
            <div class="center-maincnt">
               <div class="inr-container">
                  <div class="center-inrcnt">
                     <div className="termspage-maincnt">
                        <section class="privacy_policy_sec_1">
                           <div class="banner-privacy my-4">
                              <img src={termsimg} style={{ width: "840px", height: "166px" }} className="aboutimg" />


                           </div>
                           <div class="pri_pol_cd">
                              <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
                              <div dangerouslySetInnerHTML={{ __html: content }}></div>


                           </div>

                        </section>
                     </div>
                  </div>
                  <Footer />
               </div>
            </div>
         </div>
      </Fragment>
   );

}

export default Terms;